// controllers/video_controller.js
import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    this.keydownHandler = this.handleKeydown.bind(this);
    document.addEventListener('keydown', this.keydownHandler);

    // Initialize the YouTube player when the controller connects
    this.loadYouTubeAPI();
  }

  disconnect() {
    document.removeEventListener('keydown', this.keydownHandler);
  }

  loadYouTubeAPI() {
    return new Promise((resolve) => {
      if (window.YT && window.YT.Player) {
        this.onYouTubeIframeAPIReady();
        resolve();
      } else {
        // Load the YouTube Iframe API script
        window.onYouTubeIframeAPIReady = () => {
          this.onYouTubeIframeAPIReady();
          resolve();
        };
        const tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';
        const firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
      }
    });
  }

  onYouTubeIframeAPIReady() {
    // Initialize the player
    this.player = new YT.Player('video-iframe', {
      events: {
      },
    });
    console.log(this.player);
  }

  onPlayerReady(event) {
    // Player is ready
  }

  async play() {
    // Ensure the player is initialized
    if (!this.player || typeof this.player.playVideo !== 'function') {
      await this.loadYouTubeAPI();
    }

    const videoContainer = document.getElementById('video-container');
    videoContainer.classList.remove('hidden');

    // Call playVideo() in direct response to user interaction
    this.player.playVideo();
  }

  close() {
    const videoContainer = document.getElementById('video-container');
    videoContainer.classList.add('hidden');    

    if (this.player && typeof this.player.pauseVideo === 'function') {
      this.player.pauseVideo();
    }
  }

  handleKeydown(event) {
    if (event.key === 'Escape') {
      this.close();
    }
  }
}
